export const insertId = (pathWithIdParam: string, id: string): string => pathWithIdParam.replace(':id', id);

export const insertCode = (pathWithIdParam: string, code: string): string => pathWithIdParam.replace(':code', code);

export const insertParams = (pathWithParams: string, params: Record<string, string>): string => {
  return Object.keys(params).reduce(
    (pathString, param) => pathString.replace(`:${param}`, params[param]),
    pathWithParams,
  );
};
